import React, { useState } from 'react';
import { Package, Search } from 'lucide-react';

const unitPrice = (item) => {
  for (const key of ['prix_effectif', 'prix_vente', 'prix']) {
    const v = parseFloat(item?.[key]);
    if (v > 0) return v;
  }
  return 0;
};

const RepairStockSearch = ({
  api,
  magasinId,
  onSelect,
  placeholder = 'Rechercher une pièce (réf., désignation…)',
  disabled = false,
  excludeRefs = [],
}) => {
  const [query, setQuery] = useState('');
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const search = async (q) => {
    setQuery(q);
    if (q.length < 2) {
      setItems([]);
      setOpen(false);
      return;
    }
    setLoading(true);
    try {
      const params = {};
      if (magasinId) params.magasin_id = magasinId;
      const res = await api.get(`/stock/search/${encodeURIComponent(q)}`, { params });
      const list = (res.data || []).filter((a) => !excludeRefs.includes(a.reference));
      setItems(list);
      setOpen(list.length > 0);
    } catch (err) {
      console.error(err);
      setItems([]);
    }
    setLoading(false);
  };

  const pick = (item) => {
    onSelect?.({
      reference: item.reference,
      designation: item.designation || item.reference,
      quantite: item.quantite ?? 0,
      unit_price: unitPrice(item),
    });
    setQuery('');
    setItems([]);
    setOpen(false);
  };

  return (
    <div className="relative" data-testid="repair-stock-search">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
        <input
          type="text"
          value={query}
          onChange={(e) => search(e.target.value)}
          onBlur={() => setTimeout(() => setOpen(false), 180)}
          onFocus={() => items.length > 0 && setOpen(true)}
          className="w-full rounded-lg bg-black/30 border border-white/10 text-white pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:border-red-500/40 min-h-[44px] disabled:opacity-50"
          placeholder={placeholder}
          disabled={disabled || !magasinId}
        />
      </div>
      {!magasinId && (
        <p className="text-[10px] text-amber-400/80 mt-1">Sélectionnez d&apos;abord le magasin.</p>
      )}
      {loading && <p className="text-[10px] text-gray-500 mt-1">Recherche…</p>}
      {open && items.length > 0 && (
        <div className="autocomplete-results z-20">
          {items.map((item) => (
            <button
              key={`${item.reference}-${item.magasin_id || ''}`}
              type="button"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => pick(item)}
              className="autocomplete-item w-full text-left"
            >
              <div className="flex items-start gap-2">
                <Package className="w-3.5 h-3.5 text-cyan-400 shrink-0 mt-0.5" />
                <div className="min-w-0 flex-1">
                  <strong>{item.reference}</strong>
                  {item.designation && <span className="text-gray-400"> — {item.designation}</span>}
                  <div className="text-[10px] mt-0.5">
                    <span className={item.quantite > 0 ? 'text-emerald-400' : 'text-red-400'}>
                      {item.quantite ?? 0} dispo
                    </span>
                    {unitPrice(item) > 0 && (
                      <span className="text-gray-500 ml-2">{unitPrice(item).toFixed(2)} €</span>
                    )}
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export { unitPrice };
export default RepairStockSearch;
